var React = require('react');

function DgpLogoInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"className":"saleshub_icon","d":"M19.58,18.74h0l14.25-17a4.92,4.92,0,0,0-6.94.61L21.73,8.51a11.09,11.09,0,1,0-2.15,10.23M6.37,7.66a6.16,6.16,0,0,1,9.44,7.91h0A6.16,6.16,0,0,1,6.37,7.66","key":0}),React.createElement("path",{"className":"saleshub_icon","d":"M39,20.54a11.09,11.09,0,0,0-15.62,1.37h0L9.1,38.89a4.93,4.93,0,0,0,6.94-.6l5.16-6.15A11.09,11.09,0,1,0,39,20.54M36.56,33a6.15,6.15,0,1,1-.76-8.67A6.14,6.14,0,0,1,36.56,33","key":1})]);
}

DgpLogoInline.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 45.08 40.87"};

module.exports = DgpLogoInline;

DgpLogoInline.default = DgpLogoInline;
